import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const OfferBridgePage = () => {
  const [offer, setOffer] = useState(null);

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem('selected_offer');
      if (stored) {
        setOffer(JSON.parse(stored));
      }
    } catch (err) {
      console.warn('Could not read selected_offer from sessionStorage', err);
    }
  }, []);

  if (!offer) {
    return (
      <div className="max-w-3xl mx-auto p-6">
        <h2 className="text-lg font-bold mb-2">No recent offer found</h2>
        <p className="text-gray-400 mb-4">We couldn't find the offer you recently completed. Try opening the locker again or pick an offer from the list.</p>
        <Link to="/" className="text-indigo-400 underline">Back to Home</Link>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-2">Offer Completed</h2>
      <p className="text-gray-300 mb-4">You completed the offer:</p>
      <div className="bg-gray-900/50 p-4 rounded-lg border border-gray-800">
        <h3 className="text-lg font-bold">{offer.title || offer.id}</h3>
        {offer.description && <p className="text-sm text-gray-400">{offer.description}</p>}
        <div className="mt-4 flex items-center gap-3">
          <Link to={`/offer/${encodeURIComponent(offer.id || offer.title)}`} className="px-4 py-2 bg-indigo-600 text-white rounded-lg">Open Offer Page</Link>
          <Link to="/" className="text-gray-400 underline">Back home</Link>
        </div>
      </div>
    </div>
  );
};

export default OfferBridgePage;
